export default __webpack_public_path__ + "static/media/4318.afee6378.png";